import { addFavorites } from 'favorite/services/addFavorites'

import type { SyncFavorites } from '../types/types'
import { getCacheFavorites } from './getCacheFavorites'

export const syncFavorites = async ({
	countryISO,
	languageISO,
	token,
}: SyncFavorites): Promise<void> => {
	const cacheFavorites = await getCacheFavorites()

	if (!cacheFavorites || cacheFavorites.length === 0) {
		return
	}

	const response = await addFavorites({
		products: cacheFavorites,
		countryISO,
		languageISO,
		token,
	})

	if (!response.ok) {
		throw new Error('Failed to syncronize favorites')
	}
}
